import { themes } from '@naturacosmeticos/natds-web'

export default themes.natura.light
